export default __webpack_public_path__ + "static/banner3-87273b0b61beba5731ea281b3d8568e7.jpg";